import { useState, useRef, useEffect, type MouseEvent as ReactMouseEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { setNavbarCourses } from '@/store/slices/common/navbarCoursesSlice';
import { getCoursesOfNavBar } from '@/services/api';
import { userWebsitePaths } from '@/constants/userWebsitePaths';

import logo from "@/assets/icons/emdiSkillLogo1.png";
import DownArrow from "@/assets/svg/downArrow.svg";
import BlueDownArrow from "@/assets/svg/blueDownArrow.svg";
import WhiteDownArrow from "@/assets/icons/whiteDownArrow.png";
import darkLogo from "@/assets/icons/darkModeEmediSjillLogo1.png";


import "./style.css";
import { themes } from '@/constants/colors_v2';
import { addCurrentThemeClassToEle } from '@/utils';
import { navigateParentWindowFromIframe } from '@/utils/mainSiteNavigateFromIframe';

export { EMEDISKILL_NAVIGATE_MESSAGE } from '@/utils/mainSiteNavigateFromIframe';

/** Main-site links: in an iframe, navigate the parent (or postMessage); otherwise default `<a>` behavior. */
function handleMainSiteLinkClick(e: ReactMouseEvent<HTMLAnchorElement>, href: string | undefined | null) {
    if (typeof window === 'undefined' || window.self === window.top) return;
    if (href == null || href === '') return;
    e.preventDefault();
    navigateParentWindowFromIframe(String(href));
}

export default function VeryTopNavbar(props: any) {
    // const { showRhs, showAlways } = props
    // const dispatch = useDispatch();

    // const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    // const navbarCourses = useSelector((state: RootState) => state.navbarCoursesReducer.navbarCourses);
    // const [navbarCoursesorUI, setNavbarCoursesorUI] = useState<any>([])
    // const [activeIndex, setActiveIndex] = useState(0);

    // const [menuOpen, setMenuOpen] = useState(false);
    // const [loading, setLoading] = useState(true);
    // const [showLevel2, setShowLevel2] = useState(false);
    // const coursesRef = useRef<HTMLLIElement>(null);

    // const homePath: any = process.env.REACT_APP_USER_PANEL_URL;
    // const supportPath: any = homePath + userWebsitePaths.customerCare;
    // const offersPath: any = homePath + userWebsitePaths.offers;
    // const explorePath: any = homePath + userWebsitePaths.explore;


    // testing
    // useEffect(() => {
    //     console.log(currentTheme)
    // }, [currentTheme])


    // useEffect(() => {
    //     getCoursesOfNavBarApiCall()
    //     const onClickOutside = (e: MouseEvent) => {
    //         if (coursesRef.current && !coursesRef.current.contains(e.target as Node)) {
    //             setMenuOpen(false);
    //             setShowLevel2(false);
    //         }
    //     };
    //     document.addEventListener('mousedown', onClickOutside);
    //     return () => document.removeEventListener('mousedown', onClickOutside);
    // }, []);

    // useEffect(() => {
    //     prepareNavbarCourses()
    // }, [navbarCourses])


    // const prepareNavbarCourses = () => {
    //     if (navbarCourses.length > 0) {
    //         const courseCategories = navbarCourses?.map((category: any) => ({
    //             label: category.title,
    //             items: category.courses.map((course: any) => ({
    //                 title: course.title,
    //                 href: `${homePath}/course/${course.seoUrlSlug}`,
    //             })),
    //             categoryHref: `${homePath}/category/${category.seoUrlSlug}`
    //         })) || []
    //         setNavbarCoursesorUI(courseCategories)
    //         if (courseCategories.length > 0) {
    //             setLoading(false)
    //         }
    //     }
    // }

    // const getCoursesOfNavBarApiCall = async () => {
    //     if (navbarCourses.length === 0) {
    //         const getCoursesOfNavBarStatus = await getCoursesOfNavBar()
    //         if (getCoursesOfNavBarStatus.status) {
    //             // console.log('sasa')
    //             dispatch(setNavbarCourses(getCoursesOfNavBarStatus.data));
    //         }
    //     }
    // }

    return ( <></>
        // <nav className={`bg-white shadow fixed top-0 left-0 right-0 z-50 veryTopNavBarMainCon
        //             ${showAlways ? 'veryTopNavBarMainCon_showAlways' : ''}
        //                 `}>
        //     <div className={`vtn_div1 ${addCurrentThemeClassToEle(currentTheme, 'vtn_div1')} `}>

        //         <div className="vtn_logoCon">
        //             <a
        //                 href={homePath}
        //                 onClick={(e) => handleMainSiteLinkClick(e, homePath)}
        //             >
        //                 <img
        //                     src={currentTheme === themes.light ? logo : darkLogo}
        //                     alt="eMEDISKILL" className="vtn_emediSkilLogo" />
        //             </a>
        //         </div>

        //         {showRhs &&
        //             <ul
        //                 className="vtn_ul1">
        //                 <li>
        //                     <a href={homePath} onClick={(e) => handleMainSiteLinkClick(e, homePath)}>
        //                         Home
        //                     </a>
        //                 </li>

        //                 <li ref={coursesRef} className="relative">
        //                     <button
        //                         onClick={() => {
        //                             setMenuOpen(o => !o);
        //                             setShowLevel2(false);
        //                         }}
        //                         className="vtn_courseNavBarBtn"
        //                     >
        //                         Courses
        //                         <img
        //                             className="vtn_downArrow"
        //                             src={currentTheme === themes.light ? DownArrow : WhiteDownArrow}
        //                             alt="downArrow" />
        //                     </button>

        //                     {menuOpen && (
        //                         <div
        //                             className="vtn_courseMenu"
        //                             onMouseLeave={() => setShowLevel2(false)}
        //                         >
        //                             {/* Level 1 panel */}
        //                             <div className={`vtn_level1Menu ${addCurrentThemeClassToEle(currentTheme, 'vtn_level1Menu')}`}>
        //                                 {loading ? (
        //                                     <div className="flex justify-center items-center p-4">
        //                                         <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#1591EA]"></div>
        //                                     </div>
        //                                 ) : (
        //                                     <ul className="vtn_ul2">
        //                                         {navbarCoursesorUI.map((cat: any, idx: any) => (
        //                                             <li
        //                                                 key={cat.label}
        //                                                 onMouseEnter={() => {
        //                                                     setActiveIndex(idx);
        //                                                     setShowLevel2(true);
        //                                                 }}
        //                                                 className={`${idx === activeIndex
        //                                                     ? 'bg-[#ddebff] text-[#1491ea]'
        //                                                     : 'hover:bg-gray-100'
        //                                                     }`}
        //                                             >
        //                                                 <img
        //                                                     className="vtn_downArrow2"
        //                                                     src={idx === activeIndex ? BlueDownArrow : DownArrow}
        //                                                     alt="downArrow"
        //                                                 />
        //                                                 <span>{cat.label}</span>
        //                                             </li>
        //                                         ))}
        //                                     </ul>
        //                                 )}
        //                             </div>

        //                             {/* Level 2 panel */}
        //                             {showLevel2 && !loading && navbarCoursesorUI.length > 0 && (
        //                                 <div className={`vtn_level2Menu ${addCurrentThemeClassToEle(currentTheme, 'vtn_level2Menu')}`}>
        //                                     <ul className="vtn_ul3">
        //                                         {navbarCoursesorUI[activeIndex].items.map((item: any) => (
        //                                             <li key={item.href} className="">
        //                                                 <a
        //                                                     className="block w-48 truncate"
        //                                                     href={item.href}
        //                                                     rel="noopener noreferrer"
        //                                                     onClick={(e) => handleMainSiteLinkClick(e, item.href)}
        //                                                 >
        //                                                     {item.title.length > 40
        //                                                         ? item.title.slice(0, 37) + '…'
        //                                                         : item.title}
        //                                                 </a>
        //                                             </li>
        //                                         ))}
        //                                     </ul>
        //                                     <a
        //                                         href={navbarCoursesorUI[activeIndex].categoryHref}
        //                                         className={`vtn_bottomLink ${addCurrentThemeClassToEle(currentTheme, "vtn_bottomLink")}`}
        //                                         rel="noopener noreferrer"
        //                                         onClick={(e) =>
        //                                             handleMainSiteLinkClick(
        //                                                 e,
        //                                                 navbarCoursesorUI[activeIndex].categoryHref
        //                                             )
        //                                         }
        //                                     >
        //                                         View {navbarCoursesorUI[activeIndex].label} Details →
        //                                     </a>
        //                                 </div>
        //                             )}
        //                         </div>
        //                     )}
        //                 </li>

        //                 <li>
        //                     <a href={offersPath} onClick={(e) => handleMainSiteLinkClick(e, offersPath)}>
        //                         Offers
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a href={explorePath} onClick={(e) => handleMainSiteLinkClick(e, explorePath)}>
        //                         Explore
        //                     </a>
        //                 </li>
        //                 <li>
        //                     <a href={supportPath} onClick={(e) => handleMainSiteLinkClick(e, supportPath)}>
        //                         Support
        //                     </a>
        //                 </li>
        //             </ul>
        //         }
        //     </div>
        // </nav>
    );
}
